import React from 'react'
import { PageHeaderWithButtons } from 'components/shared'
import { AppUrls } from 'common/AppUrls'
import { UserNumbers } from './components/UserNumbers'
import { Language } from './components/Language'
import { UserInfo } from './components/UserInfo'
import { useTranslation } from 'react-i18next'
import './Account.scss'

export const Account = () => {
    const { t } = useTranslation()

    return (
        <>
            <PageHeaderWithButtons backUrl={AppUrls.settings} pageName={t('account')} />
            <UserNumbers />
            <Language />
            <UserInfo />
        </>
    )
}
